/**
 * Runs before the main app chunk loads. Compares live version.json to this document
 * and to localStorage so cached HTML without __APP_BUILD_ID__ still upgrades.
 */
import { fetchServerBuildNumber, getPageBuildId, parseBuildId } from './utils/versionCheck';

export async function ensureClientIsCurrent() {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }

  try {
    const serverBuild = await fetchServerBuildNumber();
    if (!Number.isFinite(serverBuild) || serverBuild <= 0) {
      return true;
    }

    const pageBuild = getPageBuildId();
    const lsBuild = parseBuildId(localStorage.getItem('app_version'));
    const effectiveClient = Math.max(pageBuild, lsBuild);

    if (serverBuild > effectiveClient) {
      const guardKey = `__vr_${serverBuild}`;
      const attempts = Number(sessionStorage.getItem(guardKey) || 0);
      if (attempts >= 3) {
        console.warn('[versionBootstrap] Too many reload attempts; continuing with current bundle.');
        return true;
      }
      sessionStorage.setItem(guardKey, String(attempts + 1));

      const url = new URL(window.location.href);
      url.searchParams.set('__v', String(serverBuild));
      url.searchParams.delete('_v');
      url.searchParams.delete('_cb');
      window.location.replace(url.toString());
      return false;
    }
  } catch (e) {
    console.warn('[versionBootstrap] Skipping version gate:', e?.message || e);
  }

  return true;
}
